<template>
    <div class="card">
        <div class="card-header pb-0">
            <h3>Float</h3>
        </div>
        <div class="card-body">
            <pre class="helper-classes">.f-left {
    float: left;
    }
    .f-right {
    float: right;
    }
    .f-none {
    float: none;
    }</pre>
        </div>
    </div>
    <div class="card">
        <div class="card-header pb-0">
            <h3>Overflow</h3>
        </div>
        <div class="card-body">
            <pre class="helper-classes">.o-hidden {
    overflow: hidden;
    }
    .o-visible {
    overflow: visible;
    }
    .o-auto {
    overflow: auto;
    }</pre>
        </div>
    </div>
</template>